<template>
  <div id="Zestawienie">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false" id="zestawienie">
      <div v-if="loading">
        <app-loader />
      </div>

      <div id="nav" style="width:100%; padding:5px">
        <div style="width:50%; float: left;">
          <button class="btn" @click="generateReport()" style="background: no-repeat; border: 1px solid #C1C1C1;"><img src="../../assets/img/pdf2.svg" width="34"/></button>
        </div>
        <div style="width: 50%; float: right;">
          <button
          class="btn btn-default"
          style="float: right; margin: 5px 34px; color:#007bff;background:#fff;border:1px solid #007bff"
          @click="closeDialog(0)">{{$t('message.close')}}</button>
        </div>
      </div>

      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="file_name"
          :pdf-quality="2"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="840px"
          @progress="onProgress($event)"
          @beforeDownload="beforeDownload($event)"
          @hasDownloaded="hasDownloaded($event)"
          ref="html2Pdf"
      >

        <section slot="pdf-content">
          <section class="pdf-item">
            <div id="naglowek">
              <div style="position: relative;">
                <div>
                  <md-dialog-title>{{$t('message.system_zasilania')}}</md-dialog-title>
                  <hr class="new">
                  <p style="font-size: 16px; text-align: center; margin: 5px 0px; font-weight: bold;">
                    {{$t('message.keyGen')}}: {{outputs.keyGen.value}}</p>
                </div>
                <div style="width: 100px; text-align: center; font-size: 12px;position: absolute; right: 25px;top: 0px;line-height:12px">
                  {{$t('message.printout')}}<br>Confi-DSO<br><span style="font-weight:bold">{{ new Date().toLocaleDateString() }}</span></div>
              </div>

              <div class="container" v-if="outputs.zamawiajacy.nazwa !== ''">
                <div class="row" style="width: 790px; font-size: 12px; margin-top: 15px; margin-bottom: 20px;">
                  <hr>
                  <div class="col-sm" style="border-right: 2px solid #eee;">
                    <h5>{{$t('message.contracting')}}:</h5>
                    <ul>
                      <li>{{outputs.zamawiajacy.nazwa}}</li>
                      <li>{{outputs.zamawiajacy.adres}}</li>
                      <li>{{outputs.zamawiajacy.kod_miasta}} {{outputs.zamawiajacy.miasto}}</li>
                      <li>{{outputs.zamawiajacy.tel}}</li>
                      <li>{{outputs.zamawiajacy.email}}</li>
                      <li>{{outputs.zamawiajacy.nip}}</li>
                    </ul>
                  </div>
                  <div class="col-sm" style="border-right: 2px solid #eee;">
                    <h5>{{$t('message.investment')}}:</h5>
                    <ul>
                      <li>{{outputs.inwestycja.nazwa}}</li>
                      <li>{{outputs.inwestycja.biuro_projektant}}</li>
                      <li>{{outputs.inwestycja.adres}}</li>
                      <li>{{outputs.inwestycja.kod_miasta}} {{outputs.inwestycja.miasto}}</li>
                      <li>{{outputs.inwestycja.tel}}</li>
                      <li>{{outputs.inwestycja.email}}</li>
                    </ul>
                  </div>
                  <div class="col-sm" v-if="outputs.wysylka.nazwa !== ''">
                    <h5>{{$t('message.address_shipping')}}:</h5>
                    <ul>
                      <li>{{outputs.wysylka.nazwa}}</li>
                      <li>{{outputs.wysylka.imie_nazwisko}}</li>
                      <li>{{outputs.wysylka.adres}}</li>
                      <li>{{outputs.wysylka.kod_miasta}} {{outputs.inwestycja.miasto}}</li>
                      <li>{{outputs.wysylka.tel}}</li>
                    </ul>
                  </div>
                  <hr>
                </div>
              </div>
            </div>
            <div id="daneTabele" class="dane">
              <!-- <Results/> -->
              <h5 style="text-transform: uppercase;">{{$t('message.input_data')}}</h5>
              <table>
                  <tr>
                    <td width=340>{{$t('message.hold_time')}}</td><td>{{inputs.czas_podtrzymania.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.alarm_time')}}</td><td>{{inputs.czas_alarmowania.value}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.inc_safety')}}</td><td>30</td>
                  </tr>
                  <tr>
                    <td>{{$t('message.extra_u')}}</td><td>{{inputs.dodatkowe_u.value}}</td>
                  </tr>
              </table>

              <br>
              <h5 style="text-transform: uppercase;">{{$t('message.output_data')}}</h5>
              <div style="width:470px">
                <Results/>
              </div>
              <div id="widokSzafy">
                <Wizualizacja/>
              </div>
            </div>

          </section>
          <div class="html2pdf__page-break"/>

          <section class="pdf-item">
            <h5 style="text-transform: uppercase;">{{$t('message.cost')}}</h5>
            <table class="table" v-if="Object.keys(ListaPulsar).length>0">
              <thead>
                <tr>
                  <th width=450>{{$t('message.desc')}}</th>
                  <th>{{$t('message.count_pcs')}}</th>
                  <th v-if="$i18n.locale === 'pl'">Cena netto sztuka</th>
                  <th v-if="$i18n.locale === 'pl'">Wartość netto</th>
                  <th v-if="$i18n.locale === 'pl'">Rabat</th>
                  <th v-if="$i18n.locale === 'pl'">Cena netto sztuka<br>po rabacie</th>
                  <th v-if="$i18n.locale === 'pl'">Wartość netto<br>po rabacie</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{outputs.keyGen.value}}</td>
                  <td>1</td>
                  <td v-if="$i18n.locale === 'pl'">{{Math.ceil(cenaSystemuDSO)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Math.ceil(cenaSystemuDSO)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.rabat.value}}%</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(Math.ceil(cenaSystemuDSO))}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(Math.ceil(cenaSystemuDSO))}}</td>
                </tr>
                <tr v-if="inputs.obudowa_plytki.value > 0">
                  <td>{{getName(ListaPulsar, 'AWO506')}}</td>
                  <td>{{inputs.obudowa_plytki.value}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.obudowa_plytki / inputs.obudowa_plytki.value}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.obudowa_plytki}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.rabat.value}}%</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka((outputs.cena.obudowa_plytki / inputs.obudowa_plytki.value))}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(outputs.cena.obudowa_plytki)}}</td>
                </tr>
                <tr v-if="inputs.wariant2.value > 0">
                  <td>{{getName(ListaPulsar, 'DSOS24V-PRA')}}</td>
                  <td>{{inputs.wariant2.value}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.zasilacz_dsos24_pra / inputs.wariant2.value}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.zasilacz_dsos24_pra}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.rabat.value}}%</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(outputs.cena.zasilacz_dsos24_pra / inputs.wariant2.value)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(outputs.cena.zasilacz_dsos24_pra)}}</td>
                </tr>
                <tr v-if="inputs.wariant3.value > 0">
                  <td>{{getName(ListaPulsar, 'DSOS24VPU')}}</td>
                  <td>{{inputs.wariant3.value}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.obudowa_dsos24 / inputs.wariant3.value}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.obudowa_dsos24}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.rabat.value}}%</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(outputs.cena.obudowa_dsos24 / inputs.wariant3.value)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{cena_rabat_sztuka(outputs.cena.obudowa_dsos24)}}</td>
                </tr>
                <tr v-if="inputs.kolka.value > 0">
                  <td>{{getName(ListaPulsar, 'MRAKK1')}}</td>
                  <td>1</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.kolka}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.kolka}}</td>
                  <td v-if="$i18n.locale === 'pl'"> - </td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.kolka}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{outputs.cena.kolka}}</td>
                </tr>
              </tbody>
            </table>

            <div style="height:50px"></div>

            <div id="wycena" style="height:410px" v-if="$i18n.locale === 'pl'">
              <div id="wycenaContent" style="position:relative">
                <div>
                  <div style="height:30px; width:450px; float:left; font-size:16px">System zasilania DSO-PRA</div>
                  <div style="width: 300px; position: absolute; right: 0px;">Cena netto sztuka po rabacie [PLN]</div>
                </div>
                <div>
                  <div class="content-element-lista"><span>System zasilania DSO</span>
                    <div class="content-cena" style="height: 60px;"><span style="position: absolute;top: 20px;left: 55px;">{{Math.ceil(cena_rabat_sztuka(Math.ceil(cenaSystemuDSO)))}}</span></div>
                  </div>
                </div>
              </div>
              <div style="height:135px"></div>
              <div id="wycenaContent" style="position:relative">
                <div>
                  <div style="height:30px; width:450px; float:left; font-size:16px">Wyposażenie dodatkowe</div>
                  <div style="width: 300px; position: absolute; right: 0px;">Wartość netto po rabacie [PLN]</div>
                </div>
                <div>
                  <div v-if="inputs.obudowa_plytki.value > 0 || inputs.wariant2.value > 0 || inputs.wariant3.value > 0 || inputs.kolka.value > 0">
                    <div v-if="inputs.obudowa_plytki.value > 0" class="content-element-lista"><span>{{getName(ListaPulsar, 'AWO506')}}</span></div>
                    <div v-if="inputs.wariant2.value > 0" class="content-element-lista"><span>{{getName(ListaPulsar, 'DSOS24V-PRA')}}</span></div>
                    <div v-if="inputs.wariant3.value > 0" class="content-element-lista"><span>{{getName(ListaPulsar, 'DSOS24VPU')}}</span></div>
                    <div v-if="inputs.kolka.value > 0" class="content-element-lista"><span>{{getName(ListaPulsar, 'MRAKK1')}}</span></div>
                    <div class="content-cena" :style="styleObject"><span style="position: absolute;top: 35%; left: 35%;">{{Math.ceil(cenaPozostalychElementow)}}</span></div>
                  </div>
                  <div v-else>
                    <div class="content-element-lista"></div>
                  <div class="content-cena" :style="styleObject"><span style="position: absolute;top: 35%; left: 45%;">0</span></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="html2pdf__page-break"/>

<section class="pdf-item" v-if="clusterOne.powerSupply.selected && clusterOne.powerSupply.selected !== '-'">

<h5 style="text-transform: uppercase;">{{$t('message.devices')}}</h5>

<div id="tabela-klaster" v-if="clusterOne.powerSupply.selected && clusterOne.powerSupply.selected !== '-'">
  <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} 1</b></h6>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.multifunction')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterOne.powerSupply.selected}}</td>
      <td class="midd">{{clusterOne.powerSupply.ethernet}}</td>
      <td class="midd">{{clusterOne.powerSupply.sfp}}</td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output24')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.maxCurrent')}}</th><th class="midd">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterOne.output24.selected}}</td>
      <td v-if="clusterOne.output24.ethernet" class="midd">{{clusterOne.output24.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output24.maxCurrent" class="midd">{{clusterOne.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output24.countU" class="midd">{{clusterOne.output24.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 1</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterOne.output48one.selected">{{clusterOne.output48one.selected}}</td><td v-else> - </td>
      <td v-if="clusterOne.output48one.ethernet" class="midd">{{clusterOne.output48one.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48one.loudspeaker" class="midd">{{clusterOne.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48one.sfp" class="midd">{{clusterOne.output48one.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48one.poe" class="midd">{{clusterOne.output48one.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48one.currentMode" class="midd">{{clusterOne.output48one.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48one.currentAlarm" class="midd">{{clusterOne.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48one.countU" class="midd">{{clusterOne.output48one.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 2</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterOne.output48two.selected">{{clusterOne.output48two.selected}}</td><td v-else> - </td>
      <td v-if="clusterOne.output48two.ethernet" class="midd">{{clusterOne.output48two.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48two.loudspeaker" class="midd">{{clusterOne.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48two.sfp" class="midd">{{clusterOne.output48two.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48two.poe" class="midd">{{clusterOne.output48two.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48two.currentMode" class="midd">{{clusterOne.output48two.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48two.currentAlarm" class="midd">{{clusterOne.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48two.countU" class="midd">{{clusterOne.output48two.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 3</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterOne.output48three.selected">{{clusterOne.output48three.selected}}</td><td v-else> - </td>
      <td v-if="clusterOne.output48three.ethernet" class="midd">{{clusterOne.output48three.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48three.loudspeaker" class="midd">{{clusterOne.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48three.sfp" class="midd">{{clusterOne.output48three.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48three.poe" class="midd">{{clusterOne.output48three.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48three.currentMode" class="midd">{{clusterOne.output48three.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48three.currentAlarm" class="midd">{{clusterOne.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterOne.output48three.countU" class="midd">{{clusterOne.output48three.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%">
    <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
    <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ clusterOne.callStation.csDesktop }}</td></tr>
    <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ clusterOne.callStation.csWall }}</td></tr>
    <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ clusterOne.callStation.csExt }}</td></tr>
    <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ clusterOne.callStation.poePorts }}</td></tr>
    <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ clusterOne.callStation.cstEmergency }}</td></tr>
  </table>
</div>
<div id="tabela-klaster" v-if="clusterTwo.powerSupply.selected && clusterTwo.powerSupply.selected !== '-'">
  <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} 2</b></h6>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.multifunction')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterTwo.powerSupply.selected}}</td>
      <td class="midd">{{clusterTwo.powerSupply.ethernet}}</td>
      <td class="midd">{{clusterTwo.powerSupply.sfp}}</td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output24')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.maxCurrent')}}</th><th class="midd">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterTwo.output24.selected}}</td>
      <td v-if="clusterTwo.output24.ethernet" class="midd">{{clusterTwo.output24.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output24.maxCurrent" class="midd">{{clusterTwo.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output24.countU" class="midd">{{clusterTwo.output24.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 1</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterTwo.output48one.selected">{{clusterTwo.output48one.selected}}</td><td v-else> - </td>
      <td v-if="clusterTwo.output48one.ethernet" class="midd">{{clusterTwo.output48one.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48one.loudspeaker" class="midd">{{clusterTwo.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48one.sfp" class="midd">{{clusterTwo.output48one.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48one.poe" class="midd">{{clusterTwo.output48one.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48one.currentMode" class="midd">{{clusterTwo.output48one.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48one.currentAlarm" class="midd">{{clusterTwo.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48one.countU" class="midd">{{clusterTwo.output48one.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 2</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterTwo.output48two.selected">{{clusterTwo.output48two.selected}}</td><td v-else> - </td>
      <td v-if="clusterTwo.output48two.ethernet" class="midd">{{clusterTwo.output48two.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48two.loudspeaker" class="midd">{{clusterTwo.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48two.sfp" class="midd">{{clusterTwo.output48two.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48two.poe" class="midd">{{clusterTwo.output48two.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48two.currentMode" class="midd">{{clusterTwo.output48two.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48two.currentAlarm" class="midd">{{clusterTwo.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48two.countU" class="midd">{{clusterTwo.output48two.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 3</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterTwo.output48three.selected">{{clusterTwo.output48three.selected}}</td><td v-else> - </td>
      <td v-if="clusterTwo.output48three.ethernet" class="midd">{{clusterTwo.output48three.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48three.loudspeaker" class="midd">{{clusterTwo.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48three.sfp" class="midd">{{clusterTwo.output48three.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48three.poe" class="midd">{{clusterTwo.output48three.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48three.currentMode" class="midd">{{clusterTwo.output48three.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48three.currentAlarm" class="midd">{{clusterTwo.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterTwo.output48three.countU" class="midd">{{clusterTwo.output48three.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%">
    <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
    <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ clusterTwo.callStation.csDesktop }}</td></tr>
    <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ clusterTwo.callStation.csWall }}</td></tr>
    <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ clusterTwo.callStation.csExt }}</td></tr>
    <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ clusterTwo.callStation.poePorts }}</td></tr>
    <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ clusterTwo.callStation.cstEmergency }}</td></tr>
  </table>
</div>

  </section>
  <div class="html2pdf__page-break" v-if="clusterOne.powerSupply.selected && clusterOne.powerSupply.selected !== '-'"/>

<section class="pdf-item" v-if="clusterThree.powerSupply.selected && clusterThree.powerSupply.selected !== '-'">
<div id="tabela-klaster" v-if="clusterThree.powerSupply.selected && clusterThree.powerSupply.selected !== '-'">
  <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} 3</b></h6>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.multifunction')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterThree.powerSupply.selected}}</td>
      <td class="midd">{{clusterThree.powerSupply.ethernet}}</td>
      <td class="midd">{{clusterThree.powerSupply.sfp}}</td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output24')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.maxCurrent')}}</th><th class="midd">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterThree.output24.selected}}</td>
      <td v-if="clusterThree.output24.ethernet" class="midd">{{clusterThree.output24.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output24.maxCurrent" class="midd">{{clusterThree.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output24.countU" class="midd">{{clusterThree.output24.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 1</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterThree.output48one.selected">{{clusterThree.output48one.selected}}</td><td v-else> - </td>
      <td v-if="clusterThree.output48one.ethernet" class="midd">{{clusterThree.output48one.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48one.loudspeaker" class="midd">{{clusterThree.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48one.sfp" class="midd">{{clusterThree.output48one.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48one.poe" class="midd">{{clusterThree.output48one.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48one.currentMode" class="midd">{{clusterThree.output48one.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48one.currentAlarm" class="midd">{{clusterThree.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48one.countU" class="midd">{{clusterThree.output48one.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 2</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterThree.output48two.selected">{{clusterThree.output48two.selected}}</td><td v-else> - </td>
      <td v-if="clusterThree.output48two.ethernet" class="midd">{{clusterThree.output48two.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48two.loudspeaker" class="midd">{{clusterThree.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48two.sfp" class="midd">{{clusterThree.output48two.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48two.poe" class="midd">{{clusterThree.output48two.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48two.currentMode" class="midd">{{clusterThree.output48two.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48two.currentAlarm" class="midd">{{clusterThree.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48two.countU" class="midd">{{clusterThree.output48two.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 3</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterThree.output48three.selected">{{clusterThree.output48three.selected}}</td><td v-else> - </td>
      <td v-if="clusterThree.output48three.ethernet" class="midd">{{clusterThree.output48three.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48three.loudspeaker" class="midd">{{clusterThree.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48three.sfp" class="midd">{{clusterThree.output48three.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48three.poe" class="midd">{{clusterThree.output48three.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48three.currentMode" class="midd">{{clusterThree.output48three.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48three.currentAlarm" class="midd">{{clusterThree.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterThree.output48three.countU" class="midd">{{clusterThree.output48three.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%">
    <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
    <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ clusterThree.callStation.csDesktop }}</td></tr>
    <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ clusterThree.callStation.csWall }}</td></tr>
    <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ clusterThree.callStation.csExt }}</td></tr>
    <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ clusterThree.callStation.poePorts }}</td></tr>
    <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ clusterThree.callStation.cstEmergency }}</td></tr>
  </table>
</div>

<div id="tabela-klaster" v-if="clusterFour.powerSupply.selected && clusterFour.powerSupply.selected !== '-'">
  <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} 4</b></h6>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.multifunction')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterFour.powerSupply.selected}}</td>
      <td class="midd">{{clusterFour.powerSupply.ethernet}}</td>
      <td class="midd">{{clusterFour.powerSupply.sfp}}</td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output24')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.maxCurrent')}}</th><th class="midd">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterFour.output24.selected}}</td>
      <td v-if="clusterFour.output24.ethernet" class="midd">{{clusterFour.output24.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output24.maxCurrent" class="midd">{{clusterFour.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output24.countU" class="midd">{{clusterFour.output24.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 1</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterFour.output48one.selected">{{clusterFour.output48one.selected}}</td><td v-else> - </td>
      <td v-if="clusterFour.output48one.ethernet" class="midd">{{clusterFour.output48one.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48one.loudspeaker" class="midd">{{clusterFour.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48one.sfp" class="midd">{{clusterFour.output48one.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48one.poe" class="midd">{{clusterFour.output48one.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48one.currentMode" class="midd">{{clusterFour.output48one.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48one.currentAlarm" class="midd">{{clusterFour.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48one.countU" class="midd">{{clusterFour.output48one.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 2</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterFour.output48two.selected">{{clusterFour.output48two.selected}}</td><td v-else> - </td>
      <td v-if="clusterFour.output48two.ethernet" class="midd">{{clusterFour.output48two.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48two.loudspeaker" class="midd">{{clusterFour.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48two.sfp" class="midd">{{clusterFour.output48two.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48two.poe" class="midd">{{clusterFour.output48two.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48two.currentMode" class="midd">{{clusterFour.output48two.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48two.currentAlarm" class="midd">{{clusterFour.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48two.countU" class="midd">{{clusterFour.output48two.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 3</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterFour.output48three.selected">{{clusterFour.output48three.selected}}</td><td v-else> - </td>
      <td v-if="clusterFour.output48three.ethernet" class="midd">{{clusterFour.output48three.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48three.loudspeaker" class="midd">{{clusterFour.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48three.sfp" class="midd">{{clusterFour.output48three.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48three.poe" class="midd">{{clusterFour.output48three.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48three.currentMode" class="midd">{{clusterFour.output48three.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48three.currentAlarm" class="midd">{{clusterFour.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFour.output48three.countU" class="midd">{{clusterFour.output48three.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%">
    <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
    <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ clusterFour.callStation.csDesktop }}</td></tr>
    <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ clusterFour.callStation.csWall }}</td></tr>
    <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ clusterFour.callStation.csExt }}</td></tr>
    <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ clusterFour.callStation.poePorts }}</td></tr>
    <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ clusterFour.callStation.cstEmergency }}</td></tr>
  </table>
</div>

</section>
<div class="html2pdf__page-break" v-if="clusterThree.powerSupply.selected && clusterThree.powerSupply.selected !== '-'"/>

<section class="pdf-item" v-if="clusterFive.powerSupply.selected && clusterFive.powerSupply.selected !== '-'">
<div id="tabela-klaster" v-if="clusterFive.powerSupply.selected && clusterFive.powerSupply.selected !== '-'">
  <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} 5</b></h6>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.multifunction')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterFive.powerSupply.selected}}</td>
      <td class="midd">{{clusterFive.powerSupply.ethernet}}</td>
      <td class="midd">{{clusterFive.powerSupply.sfp}}</td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output24')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.maxCurrent')}}</th><th class="midd">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterFive.output24.selected}}</td>
      <td v-if="clusterFive.output24.ethernet" class="midd">{{clusterFive.output24.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output24.maxCurrent" class="midd">{{clusterFive.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output24.countU" class="midd">{{clusterFive.output24.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 1</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterFive.output48one.selected">{{clusterFive.output48one.selected}}</td><td v-else> - </td>
      <td v-if="clusterFive.output48one.ethernet" class="midd">{{clusterFive.output48one.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48one.loudspeaker" class="midd">{{clusterFive.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48one.sfp" class="midd">{{clusterFive.output48one.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48one.poe" class="midd">{{clusterFive.output48one.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48one.currentMode" class="midd">{{clusterFive.output48one.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48one.currentAlarm" class="midd">{{clusterFive.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48one.countU" class="midd">{{clusterFive.output48one.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 2</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterFive.output48two.selected">{{clusterFive.output48two.selected}}</td><td v-else> - </td>
      <td v-if="clusterFive.output48two.ethernet" class="midd">{{clusterFive.output48two.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48two.loudspeaker" class="midd">{{clusterFive.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48two.sfp" class="midd">{{clusterFive.output48two.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48two.poe" class="midd">{{clusterFive.output48two.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48two.currentMode" class="midd">{{clusterFive.output48two.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48two.currentAlarm" class="midd">{{clusterFive.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48two.countU" class="midd">{{clusterFive.output48two.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 3</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterFive.output48three.selected">{{clusterFive.output48three.selected}}</td><td v-else> - </td>
      <td v-if="clusterFive.output48three.ethernet" class="midd">{{clusterFive.output48three.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48three.loudspeaker" class="midd">{{clusterFive.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48three.sfp" class="midd">{{clusterFive.output48three.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48three.poe" class="midd">{{clusterFive.output48three.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48three.currentMode" class="midd">{{clusterFive.output48three.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48three.currentAlarm" class="midd">{{clusterFive.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterFive.output48three.countU" class="midd">{{clusterFive.output48three.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%">
    <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
    <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ clusterFive.callStation.csDesktop }}</td></tr>
    <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ clusterFive.callStation.csWall }}</td></tr>
    <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ clusterFive.callStation.csExt }}</td></tr>
    <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ clusterFive.callStation.poePorts }}</td></tr>
    <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ clusterFive.callStation.cstEmergency }}</td></tr>
  </table>
</div>

<div id="tabela-klaster" v-if="clusterSix.powerSupply.selected && clusterSix.powerSupply.selected !== '-'">
  <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} 6</b></h6>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.multifunction')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterSix.powerSupply.selected}}</td>
      <td class="midd">{{clusterSix.powerSupply.ethernet}}</td>
      <td class="midd">{{clusterSix.powerSupply.sfp}}</td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output24')}}</th><th>{{$t('message.device')}}</th><th class="midd">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd">{{ $t('message.maxCurrent')}}</th><th class="midd">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td>{{clusterSix.output24.selected}}</td>
      <td v-if="clusterSix.output24.ethernet" class="midd">{{clusterSix.output24.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output24.maxCurrent" class="midd">{{clusterSix.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output24.countU" class="midd">{{clusterSix.output24.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 1</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterSix.output48one.selected">{{clusterSix.output48one.selected}}</td><td v-else> - </td>
      <td v-if="clusterSix.output48one.ethernet" class="midd">{{clusterSix.output48one.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48one.loudspeaker" class="midd">{{clusterSix.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48one.sfp" class="midd">{{clusterSix.output48one.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48one.poe" class="midd">{{clusterSix.output48one.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48one.currentMode" class="midd">{{clusterSix.output48one.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48one.currentAlarm" class="midd">{{clusterSix.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48one.countU" class="midd">{{clusterSix.output48one.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 2</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterSix.output48two.selected">{{clusterSix.output48two.selected}}</td><td v-else> - </td>
      <td v-if="clusterSix.output48two.ethernet" class="midd">{{clusterSix.output48two.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48two.loudspeaker" class="midd">{{clusterSix.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48two.sfp" class="midd">{{clusterSix.output48two.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48two.poe" class="midd">{{clusterSix.output48two.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48two.currentMode" class="midd">{{clusterSix.output48two.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48two.currentAlarm" class="midd">{{clusterSix.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48two.countU" class="midd">{{clusterSix.output48two.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%;font-size: 12px;">
    <tr style="background: rgb(221, 221, 221);">
      <th>{{ $t('message.output48')}} 3</th><th>{{$t('message.device')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th><th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
      <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th><th class="midd short">{{ $t('message.totalPoE')}}</th>
      <th class="midd short">{{ $t('message.currentQuiescent')}}</th><th class="midd short">{{ $t('message.currentAlarm')}}</th><th class="midd short">{{ $t('message.heightOtherDivice')}}</th>
    </tr>
    <tr>
      <td></td><td v-if="clusterSix.output48three.selected">{{clusterSix.output48three.selected}}</td><td v-else> - </td>
      <td v-if="clusterSix.output48three.ethernet" class="midd">{{clusterSix.output48three.ethernet}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48three.loudspeaker" class="midd">{{clusterSix.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48three.sfp" class="midd">{{clusterSix.output48three.sfp}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48three.poe" class="midd">{{clusterSix.output48three.poe}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48three.currentMode" class="midd">{{clusterSix.output48three.currentMode}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48three.currentAlarm" class="midd">{{clusterSix.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
      <td v-if="clusterSix.output48three.countU" class="midd">{{clusterSix.output48three.countU}}</td><td v-else class="midd"> - </td>
    </tr>
  </table>

  <table style="width:90%">
    <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
    <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ clusterSix.callStation.csDesktop }}</td></tr>
    <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ clusterSix.callStation.csWall }}</td></tr>
    <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ clusterSix.callStation.csExt }}</td></tr>
    <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ clusterSix.callStation.poePorts }}</td></tr>
    <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ clusterSix.callStation.cstEmergency }}</td></tr>
  </table>
</div>
</section>
<div class="html2pdf__page-break" v-if="clusterFive.powerSupply.selected && clusterFive.powerSupply.selected !== '-'"/>

        </section>
      </vue-html2pdf>

    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import VueHtml2pdf from 'vue-html2pdf'
import Wizualizacja from '../Wizualizacja'
import Results from '../Results'
// import WizualizacjaStacji from '../WizualizacjaStacji'

export default {
  name: 'Zestawienie',
  props: ['showDialog'],
  data () {
    return {
      page: 'dane',
      file_name: 'confi-dso-' + new Date().toLocaleDateString(),
      exporting: false
    }
  },
  components: {
    Wizualizacja, VueHtml2pdf, Results
    // , Results
    // , WizualizacjaStacji
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy']),
    ...mapGetters('products', ['ListaSelected']),
    ...mapGetters('app', ['clusters']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('app', ['clusterTwo']),
    ...mapGetters('app', ['clusterThree']),
    ...mapGetters('app', ['clusterFour']),
    ...mapGetters('app', ['clusterFive']),
    ...mapGetters('app', ['clusterSix']),

    getImgUrl () {
      var iloscU = (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
      return require('../../assets/img/szafa/szafa_' + iloscU + '.png')
    },
    szafaRozmiar () {
      if (this.outputs.szafa.attributes.szerokosc !== '' && this.outputs.szafa.attributes.glebokosc !== '') {
        return this.outputs.szafa.attributes.szerokosc + 'x' + this.outputs.szafa.attributes.glebokosc
      } else {
        return ''
      }
    },
    cenaSystemuDSO () {
      // console.log('szafa: ', this.outputs.cena.szafa)
      // console.log('akumulatory: ', this.outputs.cena.akumulatory)
      // console.log('listwaD: ', this.outputs.cena.listwaD)
      // console.log('listwaZ: ', this.outputs.cena.listwaZ)
      // console.log('panelS: ', this.outputs.cena.panelS)
      // console.log('panelW: ', this.outputs.cena.panelW)
      // console.log('polka: ', this.outputs.cena.polka)
      // console.log('inne: ', this.outputs.cena.inne)

      return Number(this.outputs.cena.szafa) + Number(this.outputs.cena.akumulatory) + Number(this.outputs.cena.listwaD) + Number(this.outputs.cena.listwaZ) + Number(this.outputs.cena.panelS) + Number(this.outputs.cena.panelW) + Number(this.outputs.cena.polka) + Number(this.outputs.cena.inne)
    },
    cenaPozostalychElementow () {
      // console.log('obudowa_plytki: ', this.outputs.cena.obudowa_plytki)
      // console.log('obudowa_dsos24: ', this.outputs.cena.obudowa_dsos24)
      // console.log('zasilacz_dsos24_pra: ', this.outputs.cena.zasilacz_dsos24_pra)
      // console.log('kolka: ', this.outputs.cena.kolka)
      return Number(this.cena_rabat_sztuka(Number(this.outputs.cena.obudowa_plytki) + Number(this.outputs.cena.obudowa_dsos24) + Number(this.outputs.cena.zasilacz_dsos24_pra))) + Number(this.outputs.cena.kolka)
    },
    styleObject () {
      var high = 20
      if (this.inputs.obudowa_plytki.value > 0) {
        high += 40
      }
      if (this.inputs.wariant2.value > 0) {
        high += 40
      }
      if (this.inputs.wariant3.value > 0) {
        high += 40
      }
      if (this.inputs.kolka.value > 0) {
        high += 40
      }
      if (high === 20) {
        high += 40
      }
      return 'height: ' + high + 'px'
    },
    cena_rabat_dodatkowe () {
      var price = 0
      // if (this.inputs.obudowa_plytki.value > 0) {
      //   var cenaObudowaPlytki = this.ListaAkcesoria.obudowa_plytki.attributes.cena * this.inputs.obudowa_plytki.value
      //   price += (cenaObudowaPlytki - (cenaObudowaPlytki * (this.outputs.rabat.value / 100)))
      // }
      // if (this.inputs.wariant3.value > 0) {
      //   var cenaObudowaMikrofonu = this.ListaAkcesoria.obudowa_mikrofonu.attributes.cena * this.inputs.wariant3.value
      //   price += (cenaObudowaMikrofonu - (cenaObudowaMikrofonu * (this.outputs.rabat.value / 100)))
      // }
      // if (this.inputs.wariant4.value > 0) {
      //   var cenaObudowaZasilacza = this.ListaAkcesoria.obudowa_zasilacza.attributes.cena * this.inputs.wariant4.value
      //   price += (cenaObudowaZasilacza - (cenaObudowaZasilacza * (this.outputs.rabat.value / 100)))
      // }
      // if (this.inputs.kolka.value > 0) {
      //   var cenaKolka = this.dodatkowy_procent(this.ListaAkcesoria.kolka.attributes.cena) * this.inputs.kolka.value
      //   price += (cenaKolka - (cenaKolka * (this.outputs.rabat.value / 100)))
      // }

      return parseFloat(Number(price)).toFixed(2)
    }
  },
  methods: {
    getName (lista, kod) {
      var device = lista.filter(item => item.kod === kod)
      // console.log(device[0])
      return device[0].kod + ' - ' + device[0].nazwa
    },
    closeDialog () {
      this.$emit('clickedClose', false)
    },
    cena_rabat_sztuka (cena) {
      return parseFloat(cena - (cena * (this.outputs.rabat.value / 100))).toFixed(2)
    },
    // cena (sztuk, cena) {
    //   return parseFloat(sztuk * cena).toFixed(2)
    // },
    // cena_rabat (sztuk, cena) {
    //   return parseFloat((sztuk * cena) - ((sztuk * cena) * (this.outputs.rabat.value / 100))).toFixed(2)
    // },
    // dodatkowy_procent (wartosc) {
    //   return parseFloat(Number(wartosc) + (Number(wartosc) * (this.config.cennik.procent / 100))).toFixed(2)
    // },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.setTextColor(150)
          pdf.text('Strona ' + i + ' z ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
        }
        this.$store.commit('app/SET_LOADING', !this.loading, { root: true })
      }).save()
    },
    onProgress ({ html2pdf, options, pdfContent }) {
      this.$store.commit('app/SET_LOADING', !this.loading, { root: true })
    },
    hasDownloaded ({ html2pdf, options, pdfContent }) {
      // console.log('hasDownloaded')
    }
  }
}
</script>

<style scoped>
#Zestawienie {
  font-size: 14px;
}
#Zestawienie table tr {
height: 25px;
}
#Zestawienie .md-dialog .md-dialog-container {
    width: 920px !important;
    max-width: 1024px !important;
}
#Wizualizacja {
  transform: scale(0.75);
}
#Stacja {
transform: scale(0.25);
width: 440px;
position: absolute;
bottom: 164px;
left: -225px;
}
#Stacja ul li {
display: inline-block;
margin: 10px 10px;
}

#naglowek ul {
  margin-bottom:0px;
  line-height: 12px;
}
#naglowek ul li {
  display: block;
  margin: 0px;
}

.vue-html2pdf {
  overflow: auto;
  overflow-x: hidden;
}
section.pdf-item {
  margin-bottom: 100px;
  padding: 15px;
}
.table {
  width: 94%;
}
.table tr {
  line-height: 8px;
}
.table tr td{
  line-height: 12px;
}

.table thead th {
font-size: 12px;
line-height: 12px;
}
.col-sm {
  text-align: center;
  padding: 0px;
}
.col-sm h5 {
  text-align: center;
}
.md-avatar[data-v-1b4e33f8] {
    width: 0px;
    min-width: 20px;
    height: 28px;
    border-radius: 0px;
    margin-left: 34px;
    margin-right: 10px;
}
.tooltipShort  {
  padding:10px;
  width:300px;
  height:110px;
  font-size: 14px;
}

.content-cena {
  position: absolute;
  right: 105px;
  width: 180px;
  background: rgb(102, 102, 102) none repeat scroll 0% 0%;
  top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: white;
}
.content-element-lista {
  height: 40px;
  width: 740px;
  float: left;
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
  background: #ccc;
  padding: 0px;
}
.content-element-lista span {
  padding: 0px 10px;
  line-height: 38px;
}

section.content-wrapper {
  padding:10px
}

#daneTabele {
  position: relative;
  /* margin-left: 32px;
margin-top: 20px; */
}

hr.new {
  border: 2px solid #1F5D89;
  border-radius: 5px;
  width: 300px;
  margin: 0px auto;
}
.btn-primary {
    color: #fff;
    background-color: rgb(59, 163, 255);
    border-color:rgb(59, 163, 255);
}
.dialogZestawienie {
min-height: 892px;
max-height: 892px;
}
#zestawienie div.md-dialog-container {
  width:820px !important;
  max-width: 820px !important;
  max-width: 820px !important;

}
  .md-avatar[data-v-1b4e33f8] {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
      margin-left: 34px;
      margin-right: 10px;
  }
  .tooltipShort  {
    padding:10px;
    width:300px;
    height:110px;
    font-size: 14px;
  }
  .md-dialog-title {
padding: 0px 0px 0;
color: #1F5D89;
font-weight: bold;
margin: auto;
width: 100%;
display: block;
text-align: center;
  }

#widokSzafy {
  position: absolute; right: 330px; bottom: 5px; float: right;
}
.dane {
  height: 760px;
}
.midd {
  text-align: center;
}
.short {
  width: 70px;
}
div#tabela-klaster {
  margin: 5px 0px;
}
div#tabela-klaster table > tr th {
background-color: #f0f0f0;
font-weight: lighter;
}
div#tabela-klaster table {
font-weight: lighter;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Podsumowanie.vue